import request from "../../../utils/request";

/**
 * 获取列表
 * @returns {AxiosPromise}
 */
export function getPlatformList(){
    return request({
        url: '/sys/platform/table',
        method: 'get'
    })
}


/**
 * 新增
 * @param params
 * @returns {AxiosPromise}
 */
export function savePlatform(data){
    return request({
        url: '/sys/platform/save',
        method: 'post',
        data
    })
}

/**
 * 编辑
 * @param params
 * @returns {AxiosPromise}
 */
export function editPlatform(data){
    return request({
        url: '/sys/platform/edit',
        method: 'put',
        data
    })
}

/**
 * 删除
 * @param params
 * @returns {AxiosPromise}
 */
export function delPlatform(params){
    return request({
        url: '/sys/platform/del',
        method: 'delete',
        params
    })
}

